import React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import { ModuleCompareProvider } from 'root/apps/ModuleCompareUI/context/Context';
import ModuleCompare from 'root/apps/ModuleCompareUI/ModuleCompare';

export type ModuleCompareProps = {
  accountId: string;
};
const ModuleCompareIndex: React.FC<ModuleCompareProps> = ({ accountId }) => {
  return (
    <ModuleCompareProvider accountId={accountId}>
      <ModuleCompare />
    </ModuleCompareProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: ModuleCompareIndex,
  selector: '[data-react-root="ModuleCompareUI"]',
});

history.onChangeState(
  [
    {
      name: ['system.views.account'],
      form_name: 'view',
      tab: 'compare',
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
